<template>
    <v-row  class="room-activity-report-container-day-room-user">
        <v-col cols="12">
            <h4>Performed By: {{userDisplayName}}</h4>
        </v-col>

        <v-col cols="12" v-if="extractionData">
            <h5>Extractions performed: {{extractionData.ExtractionsAsPrimary + extractionData.ExtractionsAsAssistant}} (primary: {{extractionData.ExtractionsAsPrimary}}, assistant: {{extractionData.ExtractionsAsAssistant}})</h5>
        </v-col>

        <v-col cols="12" v-if="drawersAsArray.length > 0" class="drawers-table-container">
            <v-data-table
                :headers="drawersHeaders"
                :items="drawersAsArray"
                hide-default-footer
            >
                <template  v-slot:item="props">
                    <tr>
                        <td v-for="(header, index) in drawersHeaders" :key="index" class="text-center">
                            {{props.item[header.value]}}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>

        <v-col cols="12" v-if="observationAndOccurrenceDataAsArray.length > 0" class="observations-occurrences-table-container">
            <v-data-table
                :items="observationAndOccurrenceDataAsArray"
                hide-default-footer
                hide-default-header
            >
                <template  v-slot:item="props">
                    <tr>
                        <td class="title-text text-center">{{props.item.Text}}</td>
                        <td class="text-center">{{props.item.Data.length}}</td>
                        <td>
                            <ul>
                                <li v-for="(item) in props.item.Data" :key="item.ID">
                                    {{item.SpecimenDisplayID}} - {{item.Comment}} ({{item.Details}})
                                </li>
                            </ul>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
export default {
    components: {
        
    },
    props: [
        //eslint-disable-next-line
        "user",
        //eslint-disable-next-line
        "drawerData",
        //eslint-disable-next-line
        "observationAndOccurrenceData",
        //eslint-disable-next-line
        "extractionData"
    ],
    data() {
        return {

        }
    },
    computed: {
        userDisplayName() {
            if (this.user && this.user.User && this.user.User.trim() != ",") {
                return this.user.User;
            }

            return this.user.Email;
        },
        observationAndOccurrenceDataAsArray() {
            const array = [];

            if (this.observationAndOccurrenceData && this.observationAndOccurrenceData.MedicalObservations && this.observationAndOccurrenceData.MedicalObservations.length > 0) {
                const data = [];

                for (let i=0; i<this.observationAndOccurrenceData.MedicalObservations.length; i++) {
                    const datum = this.observationAndOccurrenceData.MedicalObservations[i];

                    data.push(datum);
                }

                array.push({
                    Text: "Medical Observations",
                    Data: data
                });
            }

            if (this.observationAndOccurrenceData && this.observationAndOccurrenceData.ControlledOccurrences && this.observationAndOccurrenceData.ControlledOccurrences.length > 0) {
                const data = [];

                for (let i=0; i<this.observationAndOccurrenceData.ControlledOccurrences.length; i++) {
                    const datum = this.observationAndOccurrenceData.ControlledOccurrences[i];

                    data.push(datum);
                }

                array.push({
                    Text: "Controlled Occurrences",
                    Data: data
                });
            }

            if (this.observationAndOccurrenceData && this.observationAndOccurrenceData.DangerousOccurrences && this.observationAndOccurrenceData.DangerousOccurrences.length > 0) {
                const data = [];

                for (let i=0; i<this.observationAndOccurrenceData.DangerousOccurrences.length; i++) {
                    const datum = this.observationAndOccurrenceData.DangerousOccurrences[i];

                    data.push(datum);
                }

                array.push({
                    Text: "Dangerous Occurrences",
                    Data: data
                });
            }

            return array;
        },
        drawersAsArray() {
            const dataAsArray = [];

            if (this.drawerData) {
                dataAsArray.push(this.drawerData);
            }

            return dataAsArray;
        },
        drawersHeaders() {
            if (!this.drawerData || !this.drawerData.IncludedDrawers || this.drawerData.IncludedDrawers.length <= 0) {
                return [];
            }

            const headers = [];

            headers.push({
                text: "Total Specimens Cleaned",
                value: "TotalSpecimens",
                sortable: false,
                align: "center"
            });

            for (let i=0; i<this.drawerData.IncludedDrawers.length; i++) {
                const drawer = this.drawerData.IncludedDrawers[i];

                headers.push({
                    text: drawer.DrawerText,
                    value: drawer.DrawerText,
                    sortable: false,
                    align: "center"
                });
            }

            return headers;
        }
    },
    methods: {
        
    },
    created() {
        
    }
}

</script>

<style lang="scss" scoped>

</style>>